import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "container",
        "template",
        "empty",
        "count",
        "total",
        "remaining"
    ]

    static values = {
        feedAmount: Number
    }

    connect() {
        this.matches = []
        window.financeReconciliation = this
        this.render()
    }

    // ================================
    // EVENT HANDLERS (from pickers)
    // ================================

    add(event) {
        console.log(event)
        const item = event.detail

        // prevent duplicates
        if (this.matches.some(m => m.type === item.type && m.id === item.id)) {
            return
        }

        this.matches.push(item)
        this.render()
    }

    remove(event) {
        const item = event.detail

        this.matches = this.matches.filter(
            m => !(m.type === item.type && m.id === item.id)
        )

        this.render()
    }

    updateAmount(event) {
        console.log(event)
        const item = event.detail

        const match = this.matches.find(
            m => m.type === item.type && m.id === item.id
        )

        if (match) {
            match.amount = item.amount || 0
            this.render()
        }
    }

    // ================================
    // ROW ACTIONS
    // ================================

    removeRow(event) {
        const index = parseInt(event.currentTarget.dataset.index, 10)
        const removed = this.matches[index]

        this.matches.splice(index, 1)
        this.render()
        console.log(removed)

        // 🔥 Notify pickers to untick
        this.element.dispatchEvent(
            new CustomEvent("finance-reconciliation:untick", {
                detail: removed,
                bubbles: true
            })
        )
    }

    changeAmount(event) {
        const index = parseInt(event.currentTarget.dataset.index, 10)
        const value = parseFloat(event.currentTarget.value)

        this.matches[index].amount = isNaN(value) ? 0 : value
        this.renderTotals()
    }

    // ================================
    // RENDERING
    // ================================

    render() {
        this.containerTarget.innerHTML = ""

        if (this.matches.length === 0) {
            this.emptyTarget.classList.remove("d-none")
        } else {
            this.emptyTarget.classList.add("d-none")
        }

        this.matches.forEach((match, index) => {
            console.log(match)
            const row = this.templateTarget.content.cloneNode(true)

            // Title
            row.querySelector("[data-reconciliation-target='title']").textContent =
                match.title || "Record"

            // Subtitle
            row.querySelector("[data-reconciliation-target='subtitle']").textContent =
                match.subtitle || ""

            // Amount input
            const amountInput =
                row.querySelector("[data-reconciliation-target='amount']")

            amountInput.textContent = this.format(match.amount)

            // Remove button
            const removeBtn = row.querySelector("button")
            removeBtn.dataset.index = index
            removeBtn.addEventListener("click", e => this.removeRow(e))

            // Hidden inputs
            row.querySelector("[name='matches[][type]']").value = match.type
            row.querySelector("[name='matches[][id]']").value = match.id
            row.querySelector("[name='matches[][amount]']").value = match.amount || 0
            if (match.payload) {
                row.querySelector("[name='matches[][payload]']").value = JSON.stringify(match.payload)
            } else {
                row.querySelector("[name='matches[][payload]']").value = ""
            }

            this.containerTarget.appendChild(row)
        })

        this.countTarget.textContent = `${this.matches.length} items`

        this.renderTotals()
    }

    renderTotals() {
        const total = this.matches.reduce(
            (sum, m) => sum + (parseFloat(m.amount) || 0),
            0
        )

        const remaining = (this.feedAmountValue || 0) - total
        this.setReceiveMoneyTotal(remaining)
        this.setSpendMoneyTotal(remaining)
        this.setTransferTotal(remaining)

        this.totalTarget.textContent = this.format(total)
        this.remainingTarget.textContent = this.format(remaining)

        let valid = false
        if (remaining === 0) {
            this.remainingTarget.classList.remove("fg-danger")
            this.remainingTarget.classList.add("fg-success")
            valid = true
        } else {
            this.remainingTarget.classList.remove("fg-success")
            this.remainingTarget.classList.add("fg-danger")
        }

        // 🔥 Emit global form state event
        this.element.dispatchEvent(
            new CustomEvent("form:state", {
                bubbles: true,
                detail: { valid }
            })
        )
    }

    // ================================
    // SUBMIT
    // ================================

    submit() {
        if (this.matches.length === 0) {
            alert("Please select at least one match")
            return
        }

        const total = this.matches.reduce(
            (sum, m) => sum + (parseFloat(m.amount) || 0),
            0
        )

        if (total !== this.feedAmountValue) {
            alert("Total matched amount must equal the bank feed amount")
            return
        }

        // Submit parent form
        this.element.closest("form")?.requestSubmit()
    }

    setReceiveMoneyTotal(remainingAmount) {
        const tab = document.querySelector("#tab-receive")
        console.log(tab)
        if (!tab) return

        const totalField = tab.querySelector(
            "[data-finance-receipt-receive-target='receiptTotal']"
        )
        console.log(remainingAmount)
        console.log(totalField)
        if (totalField) totalField.value = remainingAmount
    }

    setTransferTotal(remainingAmount) {
        const tab = document.querySelector("#tab-transfer")
        console.log(tab)
        if (!tab) return

        const amountField = tab.querySelector(
            "[name='transfer[amount]']"
        )
        console.log(remainingAmount)
        console.log(amountField)
        if (amountField) amountField.value = remainingAmount
    }

    setSpendMoneyTotal(remainingAmount) {
        const tab = document.querySelector("#tab-spend")
        if (!tab) return

        const totalField = tab.querySelector(
            "[data-finance-payment-spend-target='paymentTotal']"
        )

        if (totalField) {
            totalField.value = remainingAmount
            totalField.dispatchEvent(new Event("input"))
        }
    }

    // ================================
    // HELPERS
    // ================================

    format(value) {
        return new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value)
    }
}
